// Auth form validation utilities — shared across modals
(function () {
  'use strict';

  var emailRe = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function fieldRoot(input) {
    return input.closest('.gn-auth-field');
  }

  function setFieldError(input, message) {
    var root = fieldRoot(input);
    if (!root) return;
    var err = root.querySelector('.gn-auth-field__error');
    input.classList.add('is-invalid');
    input.setAttribute('aria-invalid', 'true');
    if (err) {
      err.textContent = message;
      err.removeAttribute('hidden');
    }
  }

  function clearFieldError(input) {
    var root = fieldRoot(input);
    if (!root) return;
    var err = root.querySelector('.gn-auth-field__error');
    input.classList.remove('is-invalid');
    input.removeAttribute('aria-invalid');
    if (err) {
      err.textContent = '';
      err.setAttribute('hidden', '');
    }
  }

  function validateInput(input) {
    var type = (input.getAttribute('type') || '').toLowerCase();
    var name = input.getAttribute('name') || '';
    var value = (input.value || '').trim();
    var label = '';
    var root = fieldRoot(input);
    if (root) {
      var lab = root.querySelector('.gn-auth-field__label');
      if (lab) label = lab.textContent.trim();
    }

    if (input.hasAttribute('required') && !value) {
      return label ? 'Vui lòng nhập ' + label.toLowerCase() : 'Vui lòng nhập thông tin này';
    }
    if (!value) return '';

    if (type === 'email' && !emailRe.test(value)) {
      return 'Email không hợp lệ';
    }
    if (type === 'tel' || name === 'phone') {
      var digits = value.replace(/\D/g, '');
      if (digits.length < 8) return 'Số điện thoại không hợp lệ';
    }
    if (type === 'password' && value.length < 6) {
      return 'Mật khẩu phải có ít nhất 6 ký tự';
    }
    return '';
  }

  function validateOtp(form) {
    var group = form.querySelector('.gn-auth-otp');
    if (!group) return true;
    var digits = group.querySelectorAll('.gn-auth-otp__digit');
    var valid = true;
    digits.forEach(function (digit) {
      var ok = /^\d$/.test(digit.value);
      digit.classList.toggle('is-invalid', !ok);
      digit.setAttribute('aria-invalid', ok ? 'false' : 'true');
      if (!ok) valid = false;
    });
    var err = form.querySelector('.gn-auth-field__error');
    if (err) {
      err.textContent = valid ? '' : 'Vui lòng nhập đủ 6 số OTP';
      if (valid) err.setAttribute('hidden', '');
      else err.removeAttribute('hidden');
    }
    return valid;
  }

  function validateForm(form) {
    var ok = true;
    var firstInvalid = null;
    form.querySelectorAll('.gn-auth-field__input').forEach(function (input) {
      var message = validateInput(input);
      if (message) {
        setFieldError(input, message);
        if (!firstInvalid) firstInvalid = input;
        ok = false;
      } else {
        clearFieldError(input);
      }
    });
    if (form.querySelector('.gn-auth-otp') && !validateOtp(form)) {
      ok = false;
      if (!firstInvalid) firstInvalid = form.querySelector('.gn-auth-otp__digit.is-invalid');
    }
    if (firstInvalid) firstInvalid.focus();
    return ok;
  }

  function bindFieldClear(form) {
    form.querySelectorAll('.gn-auth-field__input, .gn-auth-otp__digit').forEach(function (input) {
      input.addEventListener('input', function () {
        if (input.classList.contains('gn-auth-otp__digit')) {
          var group = input.closest('.gn-auth-otp');
          var root = fieldRoot(input);
          input.classList.remove('is-invalid');
          input.removeAttribute('aria-invalid');
          if (group && !group.querySelector('.gn-auth-otp__digit.is-invalid') && root) {
            var err = root.querySelector('.gn-auth-field__error');
            if (err) {
              err.textContent = '';
              err.setAttribute('hidden', '');
            }
          }
          return;
        }
        clearFieldError(input);
      });
    });
  }

  // Expose globally for main.js
  window.GnValidate = {
    setFieldError: setFieldError,
    clearFieldError: clearFieldError,
    validateForm: validateForm,
    bindFieldClear: bindFieldClear
  };
})();
